import styled from 'styled-components';
import Body from 'components/common/body';
import { getTagColor } from 'utils/tags';
import { noScrollBarCss, theme } from 'utils/theme';

interface DivProps {
  wrap?: boolean;
  centered?: boolean;
}

const Div = styled.div<DivProps>`
  width: 100%;
  max-width: 100%;
  ${(props) => (props.wrap ? 'flex-wrap: wrap;' : 'overflow: scroll;')}

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${(props) => (props.centered ? 'center' : 'flex-start')};

  ${noScrollBarCss};
`;

const TagDiv = styled.div`
  background-color: ${theme.colors.gray50};
  padding: 0 8px;
  border-radius: 10px;
  margin: 5px 10px 5px 0;
`;

type TagRowProps = {
  tags?: string[];
  noHashtag?: boolean;
} & DivProps;

const TagRow = ({ tags, noHashtag, wrap, centered }: TagRowProps) =>
  tags ? (
    <Div wrap={wrap} centered={centered}>
      {tags.map((tag, idx) => (
        <TagDiv key={idx}>
          <Body noWrap size="small" color={getTagColor(tag)}>
            {noHashtag ? '' : '#'}
            {tag}
          </Body>
        </TagDiv>
      ))}
    </Div>
  ) : null;

export default TagRow;
